import { DATE_UNIT, DateUtils } from "shared/dateUtils";
import FazendaService from "../../services/FazendaService";
import ConciliacaoService from "./conciliacaoService";
export class ConciliacaoManager {
  async listarConciliacoesFazenda(
    idFazenda,
    dataInicial,
    dataFinal,
    inicioConciliacao
  ) {
    return await ConciliacaoService.listarConciliacoes(
      idFazenda,
      dataInicial,
      dataFinal,
      inicioConciliacao
    );
  }
  async detalhesCategoriaConciliacao(
    idFazenda,
    idCategoria,
    dataInicial,
    dataFinal
  ) {
    return await ConciliacaoService.detalhesCategoriaConciliacao(
      idFazenda,
      idCategoria,
      DateUtils.parse(dataInicial).startOf(DATE_UNIT.DAY),
      DateUtils.parse(dataFinal).endOf(DATE_UNIT.DAY)
    );
  }
  async salvaDataInicioConciliacao(dataInicioConciliacao, idFazenda) {
    const response = await FazendaService.salvaDataConciliacao(
      dataInicioConciliacao,
      idFazenda
    );
    return response.data;
  }
}

const conciliationManager = new ConciliacaoManager();
export default conciliationManager;
